import { useEffect, useState, useRef, lazy, Suspense } from "react";
import { InputGroup } from "react-bootstrap";
import { CategoriaManager } from "managers";
import ToolTip from "components/ToolTip/ToolTip";
import { DEFAULT_PAGINATION_VALUES } from "utils";
import { GridView } from "components/GridView/GridView";
import IconButton from "components/IconButton/IconButton";
import { Categoria } from "models/ECF/Categoria";
import useExceptionHandler from "hooks/useExceptionHandler";
import { AutoComplete, SvgComponent } from "components";
import SuspenseECF from "components/Suspense/SuspenseECF";
import { Simplebar } from "components/Simplebar/Simplebar";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import Select from "react-select";
import {
  buttonStyle,
  controlsProportion,
  initialWhere,
  initialWhereModal,
} from "..";
import "../Lookup.style.scss";

export const CategoriaLookup = ({
  initialValue = { label: "", value: "" },
  onChange,
  isDisabled,
  isInput = false,
  searchValue = true,
}) => {
  const ref = useRef(null);
  const [showCanvas, setShowCanvas] = useState(false);

  const [listModal, setListModal] = useState([]);
  const [whereModal, setWhereModal] = useState(initialWhereModal ?? {});
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES ?? {});
  const [selectedValue, setSelectedValue] = useState({ label: "", value: 0 });

  const { handleException } = useExceptionHandler();
  const { setPaginationValuesWhere } = usePaginationValuesWhere();
  const ESTATUS_LIST = [
    { value: "", label: "Todas" },
    ...Categoria.ESTATUS_LIST,
  ];
  const LabelsHolders = {
    placeholder: "Categoria",
    message: "Seleccionar Categoria",
  };

  useEffect(() => {
    if (whereModal != initialWhereModal) {
      buscar();
    }
  }, [whereModal]);

  useEffect(() => {
    if (
      initialValue.value &&
      initialValue.value != "" &&
      initialValue.value !== selectedValue.value &&
      initialValue.value !== -1
    ) {
      if (searchValue) {
        setValue();
      } else {
        setSelectedValue(initialValue);
      }
    }
  }, [initialValue.value]);

  const setValue = () => {
    CategoriaManager.buscarPorId(initialValue.value, true).then((data) =>
      setSelectedValue(data)
    );
  };

  const handleSelectChange = (value) => {
    setSelectedValue(value ? value : {});
    onChange(value ? value : {});
  };

  function buscar() {
    if (!whereModal || !pagination) return;
    const whereWithPaginationValues = { ...whereModal, ...pagination };
    CategoriaManager.listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers ?? {}, pagination, setPagination);
        setListModal(res.Data ?? []);
      })
      .catch((err) => handleException(err));
  }

  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const res = await CategoriaManager.listado({
      ...initialWhere,
      Nombre: inputValue,
    });
    return res.Data;
  };

  const handleCerrar = () => {
    setShowCanvas(false);
    setWhereModal(initialWhereModal);
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhereModal({ ...whereModal });
  };

  return (
    <>
      {!isInput ? (
        <InputGroup>
          <div style={{ width: controlsProportion.input }}>
            <AutoComplete
              placeholder={LabelsHolders.placeholder}
              getList={getSuggestions}
              parentValue={selectedValue}
              setParentValue={handleSelectChange}
              noBorderRadius={isInput}
              isDisabled={isDisabled}
            />
          </div>
          <InputGroup.Append style={{ width: controlsProportion.button }}>
            <AnimatedIconButton
              size="40px"
              height="18"
              width="18"
              message={LabelsHolders.message}
              style={buttonStyle}
              disabled={isDisabled}
              iconName="search"
              onClick={() => {
                setShowCanvas(true);
                setTimeout(() => {
                  buscar();
                }, 200);
              }}
            />
          </InputGroup.Append>
        </InputGroup>
      ) : (
        <>
          <div style={{ width: controlsProportion.inputGroup }}>
            <AutoComplete
              placeholder={LabelsHolders.placeholder}
              getList={getSuggestions}
              parentValue={selectedValue}
              setParentValue={handleSelectChange}
              noBorderRadius={isInput}
              isDisabled={isDisabled}
            />
          </div>
          <InputGroup.Append style={{ width: controlsProportion.button }}>
            <AnimatedIconButton
              size="40px"
              height="18"
              width="18"
              message={LabelsHolders.message}
              style={buttonStyle}
              disabled={isDisabled}
              iconName="search"
              onClick={() => {
                setShowCanvas(true);
                setTimeout(() => {
                  buscar();
                }, 200);
              }}
            />
          </InputGroup.Append>
        </>
      )}
      {showCanvas && (
        <Suspense fallback={<SuspenseECF />}>
          <Simplebar
            ref={ref}
            backdrop={true}
            placement={"end"}
            portal={false}
            size="lg"
            useLoading={false}
            visible={showCanvas}
            setShow={(e) => {
              setShowCanvas(e);
            }}
            title={LabelsHolders.message}
            btnLeft={{
              show: false,
              func: () => { },
            }}
            btnRight={{
              show: false,
              func: () => { },
            }}
          >
            <GridView
              pagination={pagination ?? {}}
              setPagination={setPagination}
              allowPaging={pagination?.EsPaginable ?? false}
              pageSize={pagination?.CantidadPorPagina ?? 10}
              pageIndex={pagination?.IndiceDePagina ?? 0}
              lastPageNumber={pagination?.PaginasTotal ?? 1}
              dataSource={listModal ?? []}
              onPageIndexChanging={onPageIndexChanging}
              where={whereModal ?? {}}
              setWhere={setWhereModal}
            >
              <GridView.Column
                isSticky
                bodyRenderer={(row) => {
                  return !row ? null :
                    (
                      <div className="float-right">
                        <IconButton
                          onClick={() => {
                            handleSelectChange({
                              value: row.IdSec,
                              label: row.Nombre,
                            });
                            handleCerrar();
                          }}
                        >
                          <ToolTip message="Seleccionar">
                            <div>
                              <SvgComponent
                                height="20"
                                width="20"
                                iconName="check"
                              />
                            </div>
                          </ToolTip>
                        </IconButton>
                      </div>
                    );
                }}
              />
              <GridView.Column
                headerText="Nombre"
                dataField="Nombre"
                sortExpression="Nombre"
              />
              <GridView.Column
                headerText="Estatus"
                dataField="Estatus"
                sortExpression="Estatus"
                filterRenderer={() => {
                  return (
                    <Select
                      className="react-select primary"
                      options={ESTATUS_LIST}
                      value={ESTATUS_LIST.filter(function (option) {
                        return (
                          option.value ===
                          (whereModal.Estatus
                            ? whereModal.Estatus
                            : ESTATUS_LIST[0].value)
                        );
                      })}
                      name="Estatus"
                      onChange={(e) =>
                        setWhereModal({
                          ...whereModal,
                          Estatus: e.value,
                        })
                      }
                    />
                  );
                }}
              />
            </GridView>
          </Simplebar>
        </Suspense>
      )}
    </>
  );
};
